var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecondStepIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "#C2C2C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.001 55C32.617 55 32.281 54.868 31.993 54.604C31.729 54.34 31.597 54.004 31.597 53.596C31.597 53.236 31.729 52.912 31.993 52.624L42.901 39.736C43.501 39.088 43.981 38.368 44.341 37.576C44.701 36.76 44.881 36.004 44.881 35.308C44.881 34.18 44.653 33.184 44.197 32.32C43.765 31.456 43.141 30.784 42.325 30.304C41.533 29.8 40.621 29.548 39.589 29.548C38.581 29.548 37.657 29.812 36.817 30.34C36.001 30.844 35.353 31.528 34.873 32.392C34.417 33.256 34.189 34.228 34.189 35.308C34.189 35.692 34.057 36.016 33.793 36.28C33.529 36.544 33.193 36.676 32.785 36.676C32.401 36.676 32.065 36.544 31.777 36.28C31.513 36.016 31.381 35.692 31.381 35.308C31.381 33.7 31.741 32.26 32.461 30.988C33.181 29.716 34.153 28.708 35.377 27.964C36.625 27.22 38.029 26.848 39.589 26.848C41.149 26.848 42.529 27.208 43.729 27.928C44.953 28.648 45.901 29.644 46.573 30.916C47.269 32.188 47.617 33.652 47.617 35.308C47.617 36.1 47.485 36.856 47.221 37.576C46.981 38.296 46.645 38.992 46.213 39.664C45.781 40.312 45.313 40.924 44.809 41.5L35.593 52.192H46.861C47.245 52.192 47.569 52.336 47.833 52.624C48.121 52.912 48.265 53.236 48.265 53.596C48.265 54.004 48.121 54.34 47.833 54.604C47.569 54.868 47.245 55 46.861 55H33.001Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondStepIcon);
export default __webpack_public_path__ + "static/media/second-step-icon.5fd10885c4ce80b543cb3c1deea6e8b3.svg";
export { ForwardRef as ReactComponent };